<template>
  <div class="global-nav">
      <span class="logo">Y</span>

      <router-link class="nav-button" to="/">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="100.000000pt" height="100.000000pt" viewBox="0 0 100.000000 100.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M257 795 c-130 -102 -237 -190 -237 -195 0 -16 19 -21 40 -10 19 10 20 7 22 -257 l3 -268 138 -3 137 -3 0 201 0 200 140 0 140 0 0 -200 0 -201 138 3 137 3 3 268 c2 264 3 267 22 257 21 -11 40 -6 40 10 0 5 -35 37 -77 71 l-78 61 -5 81 -5 82 -55 0 c-54 0 -55 -1 -60 -32 l-5 -31 -94 74 c-52 41 -97 74 -100 74 -4 0 -113 -83 -244 -185z"/> <path d="M400 240 l0 -180 100 0 100 0 0 180 0 180 -100 0 -100 0 0 -180z m156 29 c10 -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z"/> </g> </svg>
        <span>Home</span>
      </router-link>

      <router-link class="nav-button" to="/resume">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="64.000000pt" height="64.000000pt" viewBox="0 0 64.000000 64.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)" stroke="none"> <path d="M100 540 c-22 -22 -26 -51 -10 -81 15 -27 95 -27 110 0 24 46 -5 101 -55 101 -14 0 -34 -9 -45 -20z m75 -45 c0 -27 -3 -30 -30 -30 -21 0 -31 5 -33 18 -6 33 6 49 35 45 24 -3 28 -8 28 -33z"/> <path d="M260 495 c0 -13 23 -15 145 -15 122 0 145 2 145 15 0 13 -23 15 -145 15 -122 0 -145 -2 -145 -15z"/> <path d="M100 360 c-22 -22 -26 -51 -10 -81 8 -14 21 -19 55 -19 47 0 65 16 65 59 0 29 -35 61 -65 61 -14 0 -34 -9 -45 -20z m75 -45 c0 -27 -3 -30 -30 -30 -21 0 -31 5 -33 18 -6 33 6 49 35 45 24 -3 28 -8 28 -33z"/> <path d="M260 315 c0 -13 23 -15 145 -15 122 0 145 2 145 15 0 13 -23 15 -145 15 -122 0 -145 -2 -145 -15z"/> <path d="M100 190 c-40 -40 -11 -110 45 -110 32 0 65 33 65 65 0 32 -33 65 -65 65 -14 0 -34 -9 -45 -20z m75 -45 c0 -27 -3 -30 -30 -30 -21 0 -31 5 -33 18 -6 33 6 49 35 45 24 -3 28 -8 28 -33z"/> <path d="M260 145 c0 -13 23 -15 145 -15 122 0 145 2 145 15 0 13 -23 15 -145 15 -122 0 -145 -2 -145 -15z"/> </g> </svg>
        <span>Resume</span>
      </router-link>

      <router-link class="nav-button" to="/about">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="64.000000pt" height="64.000000pt" viewBox="5 5 50 55" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)" stroke="none"> <path d="M244 466 c-48 -48 -48 -104 0 -152 28 -28 42 -34 76 -34 34 0 48 6 76 34 28 28 34 42 34 76 0 60 -50 110 -110 110 -34 0 -48 -6 -76 -34z m115 -1 c16 -8 34 -28 41 -45 28 -67 -44 -138 -111 -110 -44 19 -66 68 -49 110 12 29 50 59 78 60 7 0 26 -7 41 -15z"/> <path d="M225 211 c-39 -17 -105 -81 -105 -101 0 -20 21 -9 52 26 81 92 199 96 287 8 24 -24 48 -44 52 -44 34 0 -37 81 -95 109 -53 26 -136 27 -191 2z"/> </g> </svg>
        <span>About</span>
      </router-link>

      <router-link class="nav-button" to="/projects">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="128.000000pt" height="128.000000pt" viewBox="20 20 88 88" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M693 938 c-6 -7 -42 -141 -81 -298 -62 -249 -69 -287 -56 -300 12 -13 16 -13 28 0 22 24 157 582 144 597 -13 16 -23 16 -35 1z"/> <path d="M308 726 c-43 -40 -78 -79 -78 -87 0 -14 154 -159 169 -159 5 0 14 7 21 16 11 13 4 24 -50 79 l-64 64 63 66 c52 54 61 68 51 80 -7 8 -18 15 -24 15 -6 -1 -46 -34 -88 -74z"/> <path d="M859 784 c-11 -14 -4 -24 53 -80 l66 -64 -66 -64 c-57 -56 -64 -66 -53 -80 7 -9 19 -16 25 -16 6 1 47 34 90 75 65 61 77 78 70 93 -11 22 -150 152 -162 152 -5 0 -16 -7 -23 -16z"/></g></svg>
        <span>Projects</span>
      </router-link>

      <router-link class="nav-button" to="/contact">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  width="1024.000000pt" height="1024.000000pt" viewBox="0 0 1000 940" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)" stroke="none"> <path d="M5100 9839 c-1480 -94 -2784 -825 -3578 -2004 -177 -264 -357 -602 -472 -889 -405 -1009 -493 -2242 -229 -3223 217 -810 677 -1487 1315 -1935 543 -381 1185 -608 1944 -685 215 -21 816 -24 1040 -5 818 71 1590 279 2278 613 190 92 413 210 456 242 17 13 11 28 -116 288 l-135 275 -304 -151 c-325 -161 -560 -259 -836 -349 -398 -128 -856 -228 -1253 -272 -194 -21 -778 -30 -965 -15 -688 57 -1251 257 -1734 618 -151 113 -401 363 -514 514 -330 443 -524 957 -604 1599 -25 204 -25 736 0 970 69 641 219 1168 474 1672 280 555 666 1019 1135 1367 451 334 1045 582 1636 685 302 53 408 61 832 61 354 0 412 -3 560 -23 558 -76 996 -234 1400 -504 684 -457 1082 -1157 1192 -2093 19 -160 15 -659 -6 -855 -68 -633 -233 -1144 -500 -1545 -149 -224 -383 -433 -575 -515 -155 -66 -378 -91 -496 -56 -114 35 -197 121 -235 244 -54 174 -25 569 79 1098 29 145 596 2643 648 2852 l5 22 -388 -2 -389 -3 -95 -392 c-75 -311 -98 -393 -111 -393 -9 0 -31 30 -54 76 -187 368 -474 613 -863 738 -297 96 -706 112 -1045 41 -745 -155 -1402 -733 -1747 -1539 -137 -319 -225 -656 -272 -1036 -20 -163 -17 -685 5 -830 57 -376 159 -653 332 -900 217 -307 550 -508 960 -576 162 -27 506 -25 666 4 467 85 910 356 1217 745 73 92 204 287 256 380 21 37 43 67 49 67 9 0 12 -71 12 -267 0 -246 2 -274 23 -348 87 -312 303 -497 674 -577 140 -30 470 -32 623 -4 361 66 675 227 966 496 359 330 656 881 813 1505 105 420 142 779 133 1288 -6 340 -21 492 -77 772 -202 1009 -737 1768 -1585 2250 -384 219 -824 372 -1275 444 -391 63 -862 85 -1270 60z m312 -2549 c595 -125 932 -585 887 -1212 -11 -141 -57 -401 -108 -600 -165 -647 -534 -1220 -991 -1540 -328 -230 -693 -326 -1040 -274 -290 44 -493 192 -625  456 -119 237 -161 486 -152 893 7 318 43 556 128 852 225 783 728 1328 1319 1429 52 9 109 18 125 20 76 11 363 -4 457 -24z"/> </g> </svg>
        <span>Contact</span>
      </router-link>
    </div>
</template>

<script lang="ts">
export default {
  name: 'NavBar',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* ======= GLOBAL NAV ======= */
.global-nav {
	height: 100vh;
	width: var(--nav-desktop-size);
	display: flex;
	flex-direction: column;
	background-color: rgba(60, 60, 60, 0.3);
	text-align: center;
	z-index: 10;
	align-items: center;
}
.global-nav .logo {
	font-family: "Parisienne", sans-serif;
	font-weight: 700;
	width: 100%;
	font-size: 40px;
	padding: 25px 0 10px;
	color: #7999af;
}
.global-nav .nav-button {
	color: var(--color-white);
	fill: var(--color-white);
	transition: 0.3s ease;
	width: 60px;
	padding: 9px 15px;
	display: flex;
	flex-direction: column;
	align-items: center;
  cursor: pointer;
}
.global-nav .nav-button:hover, .global-nav .nav-button.router-link-active {
	color: var(--color-creamy-ocean);
	fill: var(--color-creamy-ocean);
}
.global-nav .nav-button svg {
	width: 30px;
	height: 40px;
	object-fit: contain;
}
.global-nav .nav-button svg g {
	fill: inherit;
}
.global-nav .nav-button span {
	font-size: 16px;
	text-align: center;
}

@media screen and (max-width: 700px) {
	.global-nav {
		position: fixed;
		bottom: 0;
		height: var(--nav-mobile-size);
		width: 100vw;
		flex-direction: row;
		justify-content: space-evenly;
		align-items: center;
		padding: 0;
		background-color: rgba(55, 55, 55, 1);
	}
	.global-nav .logo {
		display: none;
	}
}


@media screen and (max-width: 400px) {
	.global-nav .nav-button svg {
		width: 26px;
		height: 35px;
	}
	.global-nav .nav-button span {
		font-size: 15px;
	}
}
</style>
